import { UniversityStudyRoomTemplate } from "@/components/UniversityStudyRoomTemplate";

const UniversityOfMinnesota = () => {
  return (
    <UniversityStudyRoomTemplate
      universityName="University of Minnesota"
      universityShortName="UMN"
      slug="university-of-minnesota"
      seoTitle="UMN Study Rooms | University of Minnesota Twin Cities Study Spaces"
      seoDescription="Find study rooms at University of Minnesota including Walter and Wilson Libraries. Learn booking policies and discover CSW as an online alternative."
      seoKeywords="UMN study rooms, University of Minnesota library, Twin Cities study spaces, Walter Library study rooms, Gopher study rooms"
      canonicalUrl="/study-room/university-of-minnesota/"
      heroDescription="Navigate UMN's diverse study spaces across the Twin Cities campus."
      libraryWebsiteUrl="https://www.lib.umn.edu"
      libraryWebsiteName="UMN Libraries"
      studySpaces={[
        {
          name: "Law Library - Group Rooms",
          features: "Rooms for 6 people, up to 8 hours/day, book 3 days ahead. Not soundproof.",
          feedback: "Great for law students. Rooms lack soundproofing."
        },
        {
          name: "Walter Library",
          features: "Group rooms with 3-hour bookings. High floors offer quiet study.",
          feedback: "Beautiful historic building. Upper floors are quieter."
        },
        {
          name: "Wilson Library",
          features: "Various study zones, renovated areas with natural light.",
          feedback: "Variety of spaces. Some quiet areas limited."
        },
        {
          name: "Bio-Teaching & Learning Center",
          features: "Comfortable seating, fewer crowds, good for focused work.",
          feedback: "Hidden gem with less foot traffic."
        }
      ]}
      guideContent={
        <>
          <p>
            UMN's Law Library allows students to reserve group study rooms for up to 8 hours per day with bookings 
            available three days in advance. Rooms seat six people and are not soundproof.
          </p>
          <p className="mt-4">
            In other libraries, such as Walter and Wilson, group rooms typically allow three-hour bookings; keys must 
            be picked up within 20 minutes to avoid cancellation. Students note that quiet areas are limited.
          </p>
          <p className="mt-4">
            For guaranteed quiet, use the Law Library or the high floors of Walter Library. Reserve rooms early and 
            bring headphones since most rooms lack soundproofing. The Biology-Teaching & Learning Resource Center 
            offers comfortable seating and fewer crowds.
          </p>
        </>
      }
      summaryTips={[
        "Law Library allows up to 8 hours/day reservations",
        "Pick up keys within 20 minutes to avoid cancellation",
        "High floors of Walter Library are quietest",
        "Most rooms lack soundproofing - bring headphones",
        "Bio-Teaching Center is a hidden quiet spot"
      ]}
    />
  );
};

export default UniversityOfMinnesota;
